import { createStore } from 'redux';
import generalStates from '../reducers/General';
import {
  SET_FILTERS_DATA,
  CLEAR_FILTERS_DATA,
  PREVIOUS_PATH,
  SET_PAGINATION_CONFIG,
  CLEAR_PAGINATION_CONFIG,
  FORM_FILTERS,
  FORM_FILTERS_CLEAR,
} from '../types';

const tableActions = new Set([
  SET_FILTERS_DATA,
  CLEAR_FILTERS_DATA,
  PREVIOUS_PATH,
  SET_PAGINATION_CONFIG,
  CLEAR_PAGINATION_CONFIG,
  FORM_FILTERS,
  FORM_FILTERS_CLEAR,
]);

export const createModalStore = (parentStore) => {
  const parentGeneral = parentStore.getState().generalStates;
  const tableStore = createStore(generalStates, {
    filtersData: { ...parentGeneral.filtersData },
    formFilters: { ...parentGeneral.formFilters },
    paginationConfig: { ...parentGeneral.paginationConfig },
    previousPath: null,
  });
  let parentState;
  let tableState;
  let state;

  const getState = () => {
    const nextParent = parentStore.getState();
    const nextTable = tableStore.getState();
    if (nextParent !== parentState || nextTable !== tableState) {
      parentState = nextParent;
      tableState = nextTable;
      state = {
        ...parentState,
        generalStates: { ...parentState.generalStates, ...tableState },
      };
    }
    return state;
  };

  const dispatch = (action) => {
    if (typeof action === 'function') return action(dispatch, getState);
    return tableActions.has(action.type)
      ? tableStore.dispatch(action)
      : parentStore.dispatch(action);
  };

  return {
    getState,
    dispatch,
    subscribe: (listener) => {
      const unsubscribeParent = parentStore.subscribe(listener);
      const unsubscribeTable = tableStore.subscribe(listener);
      return () => {
        unsubscribeParent();
        unsubscribeTable();
      };
    },
  };
};
